import globalOnLoad from "./global/globalOnLoad";
import { key, queueKey } from "./global/globals";
const subscribeEvent = (callback) => {
  if (window.grecaptcha?.execute !== void 0) {
    callback();
    return;
  }
  window[key] = globalOnLoad;
  if (window[queueKey] === void 0) {
    window[queueKey] = [callback];
  } else {
    window[queueKey].push(callback);
  }
};
var subscribeEvent_default = subscribeEvent;
export {
  subscribeEvent_default as default
};
